
import {mapActions} from 'vuex';
import sulu from 'razlet-sulu-sdk/lib/mixins/sulu';
import {required, email, sameAs} from 'vuelidate/lib/validators';
import Feedback from '~/requests/feedback';

export default {
  name: 'feedback-form',
  mixins: [sulu],
  data () {
    return {
      request: new Feedback(),
    };
  },
  methods: {
    ...mapActions(['sendFeedback']),
    submit () {
      if (this.validate()) return;

      this.sendFeedback(this.request.formData)
        .then(() => {
          this.showNotification('success', this.$t('feedback.success'));
          this.resetForm();
          this.$v.$reset();
        })
        .catch(e => {
          this.showNotification('error', e.message);
          this.$.$touch();
        });
    },
    validate () {
      this.$v.$touch();
      return this.$v.$error;
    },
    isError (field) {
      return (this.$v && this.$v.request[field]?.$error);
    },
    resetForm() {
      this.request = new Feedback();
    },
    showNotification (theme, text) {
      this.$bus.$emit('add-notification', { text, theme });
    },
  },
  validations () {
    return {
      request: {
        name: { required },
        phone: { required },
        email: { required, email },
        agreement: { sameAs: sameAs(() => true) },
      },
    }; 
  },
};
